import React from 'react';

const InputFilter = ({ handleInputChange, values }) => (
  <div className="section section--sm u--padding-top-0">
    <h2 className="h4 u--margin-top-0">Search Auto Dealers</h2>
    <input
      type="text"
      name="dealers"
      className="form__input form__input--square"
      value={values.dealers}
      onChange={handleInputChange}
      placeholder="Enter A Dealer Name or Vehicle Make..."
    />
  </div>
);

export default InputFilter;
